// extracted by mini-css-extract-plugin
module.exports = {"root":"IconReviewStar_root__2-1i9","filled":"IconReviewStar_filled__3nLsb"};